import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosConfig from "../../Services/axiosConfig";
import Header from "../header/Header";
import Product from "../Products/Product";
import Productdetails from "./Productdetails";
import Footer from "../Footer/Footer";
import "./friendlyurl.css";

const FriendlyUrlComponent = () => {
  const params = useParams();
  const friendlyPath = params["*"] || params.friendlyurl || "";
  const friendlyurl = (friendlyPath.split("/").filter(Boolean).pop() || "").replace(/\/+$/, "");

  const [data, setData] = useState(null);
  const [type, setType] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!friendlyurl || friendlyurl === "404") {
      setError("The requested page could not be found.");
      setLoading(false);
      return;
    }

    setData(null);
    setType("");
    setError("");
    setLoading(true);

    const fetchFriendlyData = async () => {
      try {
        let res;
        try {
          res = await axiosConfig.get(`/catlog/seo-url/${friendlyurl}/`);
        } catch (initialErr) {
          res = await axiosConfig.get(`/catlog/seo-url/${friendlyurl}`);
        }
        setData(res?.data?.product_data);
        setType(res?.data?.product_type);
      } catch (err) {
        console.error("Error loading friendly URL", err);
        setError("The requested page could not be found.");
      } finally {
        setLoading(false);
      }
    };
    fetchFriendlyData();
  }, [friendlyurl]);

  if (loading) {
    return (
      <p className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <img src={require("../Assets/spinner.gif")} alt="Loading content" height={150} width={150} />
      </p>
    );
  }

  if (error || !data) {
    return (
      <>
        <Header />
        <main className="friendly-page-container friendly-empty-container">
          <div className="friendly-empty">
            <h1>Page not found</h1>
            <p>{error || "The requested page could not be found."}</p>
            <div className="friendly-empty-buttons">
              <button type="button" className="btn-back" onClick={() => navigate(-1)}>
                Go back
              </button>
              <button type="button" className="btn-home" onClick={() => navigate("/")}>
                Back to home
              </button>
            </div>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <div className="friendly-page-container">
        {type === "product" && (
          <Productdetails productData={data} />
        )}

        {type === "category" && (
          <Product friendlyData={data} />
        )}

        {type === "promotionalcategory" && (
          <Product products={data.results} isPromotional={true} />
        )}

        {type === "page" && (
          <>
            <Header />
            <div className="cms-page">
              <h1>{data.meta_title || data.title || data.name}</h1>
              <div dangerouslySetInnerHTML={{ __html: data.description || data.content || "" }} />
            </div>
          </>
        )}

        {!["product", "category", "promotionalcategory", "page"].includes(type) && (
          <p>Unknown content type: {type}</p>
        )}
      </div>
      <Footer />
    </>
  );
};

export default FriendlyUrlComponent;
